import { createApi } from "../../../utils/createApi";
import { saveAs } from "file-saver";

export const downloadPatrolReport = async (patrolId: string) => {
  const AxiosUI = createApi("");
  const response = await AxiosUI.get(
    `autopatrol_data/report_by_patrol_id/?patrol_id=${patrolId}`,
    { responseType: "blob" }
  );
  const blob = new Blob([response.data], { type: "text/csv" });
  saveAs(blob, `patrol_report_${patrolId}.csv`);
};
